<template>
	<transition name="fade">
		<div v-show="open" class="modal-popup" :class="{ active: open }">
			<div class="popup-overlay"></div>

			<div class="container">
				<div class="popup popup-may-scroll">
					<div class="popup-container popup-may-scroll">
						<div class="popup-form popup-may-scroll margin-top-30">
							<div class="form-container popup-may-scroll form-text-container no-border no-shadow">
								<div
									v-if="type"
									class="form-content popup-may-scroll text-left"
									v-html="$t('Page.Content.RequestTypesDetail.' + type)"
								></div>
							</div>
						</div>
					</div>

					<div class="close-btn" @click="preCloseModal">
						<i class="fa fa-close"></i>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import ModalHelper from '@/mixins/ModalHelper'

export default {
	name: 'RequestTypesModal',
	mixins: [ModalHelper],
	data() {
		return {
			type: '',
		}
	},
	mounted() {
		// Listen for open modal event
		this.$root.$on('open-request-types-modal', (type) => {
			this.type = type
			this.open = !this.open
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-request-types-modal')
	},
	methods: {
		preCloseModal() {
			this.closeModal()
		},
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/utils/modals/misc/RequestTypesModal.vue